export default __webpack_public_path__ + "static/11-137c1d77a21f752e4355287cd9398426.webp";